// import consts from "@/consts.js";
import Request from './request';

async function fetchSelectShops(id,data) {// 获取销售下已选的门店列表
    return Request('get', "api/alliance-business-shops/get-select-shops/?alliance_business_id="+id , data);
}
async function fetchUnSelectShops(id,data) {// 获取销售下未选的门店列表
    return Request('get', "api/alliance-business-shops/get-un-select-shops/?alliance_business_id="+id,data);
}

async function addShop(id,data) {//绑定单个门店
    return Request('post', "api/alliance-business-shops/add-shops/?alliance_business_id="+id , data);
}

async function addAllShops(id,data) {//绑定所有门店
  return Request('post', "api/alliance-business-shops/add-shops/?alliance_business_id="+id , data);
}

async function removeShop(id,data) {//移除单个门店
  return Request('post', "api/alliance-business-shops/remove-shops/?alliance_business_id="+id , data);
}

async function removeAllShops(id,data) {//移除所有门店
  return Request('post', "api/alliance-business-shops/remove-shops/?alliance_business_id="+id , data);
}

export default {
  fetchSelectShops,
  fetchUnSelectShops,
  addShop,
  addAllShops,
  removeShop,
  removeAllShops,
};